import { flexbox } from "@mui/system";
import React, {useState, useEffect} from "react";

import {useParams} from "react-router";

import { Link } from "react-router-dom";

import Card from "./Card";
import "./style/studios.css";
import image from "./style/6/2.jpg"
import image2 from "./style/7/1.jpg"
import image3 from "./style/1/2.jpg"
import image4 from "./style/2/1.jpg"
import image5 from "./style/3/1.jpg"

const Studio = () =>  {
    const [data, setData] = useState([]);
    const [filter, setFilter] = useState(data);
    const [loading, setLoading] = useState(false);
    let [test, setTest ] = useState(true);
    let componentMounted = true; 
    let paginaP = useParams();

    let page;

    useEffect(() => {
    console.log(paginaP.pagina)
    }, []);

    

  
   
    
    const Loading = () => {
        return (
            <>
                Carregando...
            </>
        )
    }

    const ShowStudios = () => {

        if (paginaP.pagina == 0) {
        return (
           
        <div className="STUDIOS">
            <div style={{flex:"row"}}>
              
            <a style={{color: "white",  textDecoration: "none", border:"1.5px solid white", fontFamily:"Montserrat", marginTop:"1rem"}} className="custom-btn btn-15 aos-init aos-animate" href="/"> VOLTAR</a>
            <h1>STUDIOS </h1>
            </div>
           
            <div className="studioG">
  
            <Link to={"/studios/specific/6"} style={{ textDecoration: 'none' }}>
                                <Card 
                                image={image}
                                title={"studio 302 (sem mobília)"}
                                location=""
                                description=""
                                //  {"Garden: " + (studio.temGarden ? "Sim |  " : "Não | ") 
                                //     +
                                //  "Churrasqueira: " + (studio.temChurrasqueira ? "Sim" : "Não")
                                // } 
                                studio={"ver studio"}
                                color={"2px solid #C59776"}
                                textColor={""}
                                />
            </Link>
             <Link to={"/studios/specific/7"} style={{ textDecoration: 'none' }}>
                                <Card 
                                image={image2}
                                title={"studio 501 (sem mobília)"}
                                location=""
                                description=""
                                //  {"Garden: " + (studio.temGarden ? "Sim |  " : "Não | ") 
                                //     +
                                //  "Churrasqueira: " + (studio.temChurrasqueira ? "Sim" : "Não")
                                // } 
                                studio={"ver studio"}
                                color={"2px solid #C59776"}
                                textColor={""}
                                />
            </Link>
             <Link to={"/studios/specific/1"} style={{ textDecoration: 'none' }}>
                                <Card 
                                image={image3}
                                title={"studio 102 (mobiliado)"}
                                location=""
                                description=""
                                //  {"Garden: " + (studio.temGarden ? "Sim |  " : "Não | ") 
                                //     +
                                //  "Churrasqueira: " + (studio.temChurrasqueira ? "Sim" : "Não")
                                // } 
                                studio={"ver studio"}
                                color={"2px solid #C59776"}
                                textColor={""}
                                />
            </Link>
           <Link to={"/studios/specific/8"} style={{ textDecoration: 'none' }}>
                                <Card 
                                image={image4}
                                title={"studio 403 (mobiliado)"}
                                location=""
                                description=""
                                //  {"Garden: " + (studio.temGarden ? "Sim |  " : "Não | ") 
                                //     +
                                //  "Churrasqueira: " + (studio.temChurrasqueira ? "Sim" : "Não")
                                // } 
                                studio={"ver studio"}
                                color={"2px solid #C59776"}
                                textColor={""}
                                />
            </Link>
             <Link to={"/studios/specific/12"} style={{ textDecoration: 'none' }}>
                                <Card 
                                image={image5}
                                title={"studio 802 (mobiliado)"}
                                location=""
                                description=""
                                //  {"Garden: " + (studio.temGarden ? "Sim |  " : "Não | ") 
                                //     +
                                //  "Churrasqueira: " + (studio.temChurrasqueira ? "Sim" : "Não")
                                // } 
                                studio={"ver studio"}
                                color={"2px solid #C59776"}
                                textColor={""}
                                />
            </Link>

      
                                                         
            </div>
        </div>
        )} 
    }
    return (
       <div>
           {<ShowStudios/>}
        </div>
   )
}

export default Studio;
